import fetch from "isomorphic-fetch";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/flexible-planning/quotation").GET();

export type GetFlexiblePlanningQuotationParams = typeof endpoint.types.P;
export type GetFlexiblePlanningQuotationQuery = typeof endpoint.types.Q;
export type GetFlexiblePlanningQuotationResponse = typeof endpoint.types.Res;

export async function getFlexiblePlanningQuotation(
    {
        params,
        query,
    }: {
        params: GetFlexiblePlanningQuotationParams;
        query: GetFlexiblePlanningQuotationQuery;
    },
    signal?: AbortSignal,
) {
    // Preserve the selected calendar days before Spellbook serializes dates as UTC.
    const normalizedQuery = { ...query };
    for (const key of ["startDate", "endDate"] as const) {
        const date = query[key];
        normalizedQuery[key] = new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
        );
    }
    const call = createCall(endpoint, (request) => fetch(withAccountAuthHeaders(request)));
    return await call({ params, query: normalizedQuery, signal });
}
